// import React from 'react'
import { useEffect, useState } from "react";
import { paper, Point, Size, Rectangle, Path, Segment, PointText } from "paper";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { Button, Modal, Form } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import DownloadMenu from "../../shared/DownloadMenu";
import { applyHorizontalTrace, HORIZONTAL_ALERT_FLAT } from "../utils/horizontalTrace";
const Debugoutput = (props) => {
  const { addToast } = useToasts();
  const [uservariables, setUserVariables] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedTrace, setSelectedTrace] = useState(false);
  const handleClose = () => setShow(false);

  //common variables
  let tracedimensions = props.dimensions;
  let multiplier = 5;
  let padding = 110;
  let points = 60;
  let traclength= 100;
  let length = traclength * multiplier;
  let height = tracedimensions.height * multiplier;
  let width = tracedimensions.width * multiplier;
  let hw = tracedimensions.hw * multiplier;
  let ws = tracedimensions.width * multiplier;
  let headingrd = tracedimensions.rd * multiplier;
  let scalearr = [];
  let text;
  let i = 0;
  let Whalf = ws / 2;
  let HC = height - hw;
  let r = (Math.pow(Whalf, 2) + Math.pow(HC, 2)) / (2 * HC);
  let Theta = toDegree(Math.atan((r - HC) / Whalf));
  let Arc = (Math.PI * r) / 2 - ((Math.PI * r) / 2) * (Theta / 90);
  let ArcFull = Arc * 2;
  let HWn = height - r;
  let Ymax = padding + 2 * (hw + Arc);
  let usrvar = [];
  
  //End varibales
  const updateUserVariable = (usrvar) => {
    // console.log(usrvar);
    setUserVariables(usrvar);
  };
  function toRadians(angle) {
    return angle * (Math.PI / 180);
  }
  function toDegree(radian) {
    return radian * (180 / Math.PI);
  }
  useEffect(() => {
    if (!props.showdebug) {
      paper.setup("paper-canvas");
      creategraph();
    }
  }, [props.dimensions, props.showdebug]);
  const createScale = () => {
    if (tracedimensions.iscrown) {
      Ymax = padding + 2 * Arc + hw;
    }
    for (i = padding; i <= length + padding; i += multiplier * 10) {
      text = new PointText(new Point(i, Ymax + 15));
      text.justification = "center";
      text.fillColor = "black";
      if((headingrd  ) / multiplier<(traclength/2))
      {
        text.content = Math.round((i - padding  ) / multiplier);
      }
      else
      {
        text.content = Math.round((i - padding +headingrd  ) / multiplier -(traclength/2));
      }
      
      scalearr.push([i, Ymax + 10]);
      scalearr.push([i, Ymax]);
      if (i + multiplier * 10 <= length + padding) {
        for (let j = 1; j <= 9; j++) {
          scalearr.push([i + multiplier * j, Ymax]);
          scalearr.push([i + multiplier * j, Ymax + 5]);
          scalearr.push([i + multiplier * j, Ymax]);
        }
        scalearr.push([i + multiplier * 10, Ymax]);
      }
    }
    new Path({
      segments: scalearr,
      strokeColor: "black",
      strokeWidth: 1,
    });
    if (tracedimensions.iscrown) {
      Ymax = padding + 2 * (hw + Arc);
    }
  };
  const createLog = () => {
    let style = {
      fillColor: "white",
      strokeColor: "black",
      strokeWidth: 1,
    };
    let headinglength;
    if((headingrd  ) / multiplier<(traclength/2)){
      headinglength= headingrd;
    }
    else
    {
      headinglength=length/2;
    }
      var path = new Path.Rectangle(
        new Rectangle(
          new Point(padding, padding),
          new Size(headinglength, 2 * (hw + Arc))
        )
      );
      path.style = style;
      var path1 = new Path.Rectangle(
        new Rectangle(
          new Point(padding, padding + hw),
          new Size(headinglength, 2 * Arc)
        )
      );
      path1.style = style;
    
      path.style = style;
      var dashpath = new Path.Rectangle(
        new Rectangle(
          new Point(padding+1+headinglength, padding),
          new Size(length-headinglength, 2 * (hw + Arc))
        )
      );
      
      var dashpath1 = new Path.Rectangle(
        new Rectangle(
          new Point(padding+1+(headinglength), padding + hw),
          new Size(length-headinglength, 2 * Arc)
        )
      );
      dashpath.style = style;
      dashpath.dashArray = [4, 10];
      dashpath1.style = style;
      dashpath1.dashArray = [4, 10];
    var path2 = new Path.Rectangle(
      new Rectangle(
        path.bounds.leftCenter.add([-HC-hw, -width / 2]),
        new Size(hw, width)
      )
    );
    path2.style = style;
    var path21 = new Path.Arc(
      path2.bounds.topRight,
      path.bounds.leftCenter,
      path2.bounds.bottomRight
    );
    path21.style = style;

    var path3 = new Path.Line(path.bounds.leftCenter, dashpath1.bounds.rightCenter);
    path3.strokeColor = "black";
    path3.dashArray = [4, 10];
    var directionarrowline = new Path.Line(
      path.bounds.topRight.add([-60, -30]),
      path.bounds.topRight.add([0, -30])
    );
    directionarrowline.style = style;
    var directionarrowht = new Path.Line(
      path.bounds.topRight.add([0, -30]),
      path.bounds.topRight.add([-10, -30])
    );
    directionarrowht.style = style;
    directionarrowht.rotate(45, path.bounds.topRight.add([0, -30]));
    var directionarrowhb = new Path.Line(
      path.bounds.topRight.add([0, -30]),
      path.bounds.topRight.add([10, -30])
    );
    directionarrowhb.style = style;
    directionarrowhb.rotate(135, path.bounds.topRight.add([0, -30]));
    var directionarrowlineinv = new Path.Line(
      path.bounds.topLeft.add([0, -30]),
      path.bounds.topLeft.add([60, -30])
    );
    directionarrowlineinv.style = style;
    var directionarrowhtinv = new Path.Line(
      path.bounds.topLeft.add([0, -30]),
      path.bounds.topLeft.add([-10, -30])
    );
    directionarrowhtinv.style = style;
    directionarrowhtinv.rotate(135, path.bounds.topLeft.add([0, -30]));
    var directionarrowhbinv = new Path.Line(
      path.bounds.topLeft.add([0, -30]),
      path.bounds.topLeft.add([10, -30])
    );
    directionarrowhbinv.style = style;
    directionarrowhbinv.rotate(45, path.bounds.topLeft.add([0, -30]));

    
      var path4 = new Path(
        new Segment(path.bounds.topLeft),
        new Segment(path2.bounds.topLeft)
      );
      path4.strokeColor = "black";
      path4.dashArray = [14, 5];
      var path5 = new Path(
        new Segment(path.bounds.bottomLeft),
        new Segment(path2.bounds.bottomLeft)
      );
      path5.strokeColor = "black";
      path5.dashArray = [14, 5];
      var path6 = new Path(
        new Segment(path1.bounds.topLeft),
        new Segment(path2.bounds.topRight)
      );
      path6.strokeColor = "black";
      path6.dashArray = [14, 5];
      var path7 = new Path(
        new Segment(path1.bounds.bottomLeft),
        new Segment(path2.bounds.bottomRight)
      );
      path7.strokeColor = "black";
      path7.dashArray = [14, 5];
    
      // text = new PointText(path.bounds.topLeft.add([-5, 5]));
      // text.justification = "right";
      // text.fillColor = "black";
      // text.content = "Left Invert";
      // text = new PointText(path.bounds.bottomLeft.add([-5, 5]));
      // text.justification = "right";
      // text.fillColor = "black";
      // text.content = "Right Invert";
      // text = new PointText(path1.bounds.topLeft.add([-5, 5]));
      // text.justification = "right";
      // text.fillColor = "black";
      // text.content = "Left Spring Level";
      // text = new PointText(path1.bounds.bottomLeft.add([-5, 5]));
      // text.justification = "right";
      // text.fillColor = "black";
      // text.content = "Right Spring Level";
  
    // text = new PointText(path.bounds.leftCenter.add([-5, 5]));
    // text.justification = "right";
    // text.fillColor = "black";
    // text.content = "Centerline";
    text = new PointText(directionarrowline.bounds.topLeft.add([-20, 4]));
    text.justification = "center";
    text.fillColor = "black";
    text.content = "N" + tracedimensions.direction + "\xB0";
    text = new PointText(directionarrowlineinv.bounds.topRight.add([0, 4]));
    text.justification = "left";
    text.fillColor = "black";
    let dopp =
      parseInt(tracedimensions.direction) > 180
        ? parseInt(tracedimensions.direction) - 180
        : parseInt(tracedimensions.direction) + 180;
    text.content = "N" + dopp + "\xB0";
    text = new PointText(path.bounds.topLeft.add([15-padding, 25-padding]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "α = Angle between strike and tunnel direction";
    text = new PointText(path.bounds.topLeft.add([265-padding, 25-padding]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "β = Apparent dip along tunnel";
    text = new PointText(path.bounds.topLeft.add([15-padding, 45-padding]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "P1 = Ch. Right Invert";
    text = new PointText(path.bounds.topLeft.add([155-padding, 45-padding]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "P2 = Ch. Right SPL";
    text = new PointText(path.bounds.topLeft.add([295-padding, 45-padding]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "P3 = Ch. Left Invert";
    text = new PointText(path.bounds.topLeft.add([435-padding, 45-padding]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "P4 = Ch. Left SPL";
    text = new PointText(path.bounds.topLeft.add([575-padding, 45-padding]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "P5 = Ch. Centerline";
    text = new PointText(path.bounds.bottomLeft.add([0, 40]));
    text.justification = "left";
    text.fillColor = "black";
    text.content =
      "Tunnel direction: " +
      tracedimensions.direction +
      " Height: " +
      height / multiplier +
      " Width: " +
      width / multiplier +
      " Radius: " +
      (r / multiplier).toFixed(1).replace(/\.0$/, "") +
      " Crown circumference: " +
      (ArcFull / multiplier).toFixed(1).replace(/\.0$/, "") +
      " Wall height: " +
      hw / multiplier;
  };
  const createTrace = () => {
    usrvar["Length"] = length / multiplier;
    usrvar["Height"] = height / multiplier;
    usrvar["Width"] = width / multiplier;

    usrvar["HW"] = hw / multiplier;
    usrvar["WS"] = ws / multiplier;
    usrvar["Whalf"] = Whalf / multiplier;
    usrvar["HC"] = HC / multiplier;
    usrvar["R"] = r / multiplier;
    usrvar["Theta"] = Theta;
    usrvar["Arc"] = Arc / multiplier;
    usrvar["ArcFull"] = ArcFull / multiplier;

   
      let style = {
        fillColor: "transparent",
        strokeColor: 'black',
        strokeWidth: 1,
      };
      let rd;
      let traceunion = [];
      let amt = parseInt(props.dimensions.amt);
      let D = parseInt(tracedimensions.direction);
      let Dir = parseInt(props.dimensions.dir);

      // Revise Dir / amt slightly when the trace would plot horizontal (infinite
      // persistence) so a finite trace can be drawn, mirroring the plotting step.
      const horizontal = applyHorizontalTrace(D, Dir, amt, parseInt(tracedimensions.inclination) || 0);
      D = horizontal.D;
      Dir = horizontal.Dir;
      amt = horizontal.amt;
      // The flat-plane alert is surfaced at the input page; only the
      // strike-parallel alert is raised here on the output page.
      if (horizontal.alert && horizontal.alert !== HORIZONTAL_ALERT_FLAT) {
        addToast(horizontal.alert, {
          appearance: "warning",
        });
      }

      let Dnew, Dirnew, Alpha, Value, Value1, Value2, ApDir;
      if (D > 180) {
        Dnew = D - 180;
      } else {
        Dnew = D;
      }
      if (Dir > 180) {
        Dirnew = Dir - 180;
      } else {
        Dirnew = Dir;
      }
      Value = Math.abs(Dnew - Dirnew);

      if (Value <= 90) {
        Alpha = 90 - Value;
      } else {
        Alpha = Value - 90;
      }

      // if (D > Dir) {
      //   Value2 = D - Dir;
      // } else {
      //   Value2 = Dir - D;
      // }
      Value1 = Math.abs(D - Dir);
      if (Value1 >= 0 && Value1 <= 90) {
        ApDir = D;
      } else {
        ApDir = D - 180;
      }
      let TanAlpha = Math.tan(toRadians(Alpha));
      let TanBeta = Math.tan(toRadians(amt)) * Math.sin(toRadians(Alpha));
      let H = [],
        XP = [],
        YP = [],
        XP5 = [],
        YP5 = [],
        XP3,
        XPmid,
        X2,
        Dopp;
      if (D >= 0 && D <= 180) {
        Dopp = D + 180;
      } else {
        Dopp = D - 180;
      }
      let headinglength;
    if((headingrd  ) / multiplier<(traclength/2)){
      headinglength= headingrd;
    }
    else
    {
      headinglength=length/2;
    }
      let X1 = padding + headinglength;
      let P1 = new Point(X1, Ymax);
      let Diff = D - Dir;
      if (ApDir === D) {
        if ((Diff > -360 && Diff < -270) || (Diff > 0 && Diff < 90)) {
          XP3 = X1 - width / TanAlpha;
          XPmid = X1 - Math.abs(X1 - XP3) / 2;
        } else {
          XP3 = X1 + width / TanAlpha;
          XPmid = X1 + Math.abs(X1 - XP3) / 2;
        }
        X2 = X1 - hw / TanBeta;
      } else {
        Diff = Dopp - Dir;
        if ((Diff > -360 && Diff < -270) || (Diff > 0 && Diff < 90)) {
          XP3 = X1 - width / TanAlpha;
          XPmid = X1 - Math.abs(X1 - XP3) / 2;
        } else {
          XP3 = X1 + width / TanAlpha;
          XPmid = X1 + Math.abs(X1 - XP3) / 2;
        }
        X2 = X1 + hw / TanBeta;
      }
      let P2 = new Point(X2, Ymax - hw);
      let P3 = new Point(XP3, Ymax - (2 * hw + ArcFull));
      let P4 = new Point(XP3 - hw / TanBeta, Ymax - (hw + ArcFull));
      if (ApDir !== D) {
        P4 = new Point(XP3 + hw / TanBeta, Ymax - (hw + ArcFull));
      }
      let P5;
      if (!tracedimensions.iscrown) {
        // var rwline = new Path.Line(P1, P2);
        // rwline.style=style;
        traceunion.push([P1.x, P1.y]);
        traceunion.push([P2.x, P2.y]);
      }

      scalearr = [];

      for (let n = Theta; n <= 90; n++) {
        H[n] = r * Math.sin(toRadians(n));
        if (ApDir === D) {
          if (P2.x > P4.x) {
            XP[n] = X1 - Math.abs(X1 - XPmid) * ((n - Theta) / (90 - Theta));
          } else {
            XP[n] = X1 + Math.abs(X1 - XPmid) * ((n - Theta) / (90 - Theta));
          }
          XP5[n] = XP[n] - (H[n] + HWn) / TanBeta;
        } else {
          if (P2.x > P4.x) {
          XP[n] = X1 - Math.abs(XPmid - X1) * ((n - Theta) / (90 - Theta));
          }
          else
          {
            XP[n] = X1 + Math.abs(XPmid - X1) * ((n - Theta) / (90 - Theta));
          }
          XP5[n] = XP[n] + (H[n] + HWn) / TanBeta;
        }
        YP[n] = Ymax - (hw + Arc * ((n - Theta) / (90 - Theta))); //(hw+(Arc)*(n/90));
        YP5[n] = YP[n];
        scalearr.push([XP5[n], YP5[n]]);
        traceunion.push([XP5[n], YP5[n]]);
        usrvar["Prc" + n] =
          "(" +
          (XP5[n] - padding) / multiplier +
          "," +
          (hw + Arc * ((n - Theta) / (90 - Theta))) / multiplier +
          ")";
      }

      let rcrown = new Path({
        segments: scalearr,
      });
      // let XP4=(XP3-(hw/TanBeta))>padding?XP3-(hw/TanBeta):padding;

      //left crown
      scalearr = [];
      H = [];
      XP = [];
      YP = [];
      XP5 = [];
      YP5 = [];
      for (let n = 90; n >= Theta; n--) {
        H[n] = r * Math.sin(toRadians(n));
        if (parseInt(ApDir) === D) {
          if (P2.x > P4.x) {
          XP[n] = XP3 + Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta)); //XP3+((XPmid-XP3)*(n/90));
          }
          else
          {
            XP[n] = XP3 - Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta));
          }
          XP5[n] = XP[n] - (H[n] + HWn) / TanBeta;
        } else {
          if (P2.x > P4.x) {
          XP[n] = XP3 + Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta)); //XP3+((XPmid-XP3)*(n/90));
          }
          else{
            XP[n] = XP3 - Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta));
          }
          XP5[n] = XP[n] + (H[n] + HWn) / TanBeta; //XPn-((Hn+H)/TanBeta)
        }
        YP[n] = Ymax - (hw + ArcFull - Arc * ((n - Theta) / (90 - Theta))); //(hw+ArcFull-((Arc)*(n/90)));
        YP5[n] = YP[n];
        scalearr.push([XP5[n], YP5[n]]);
        traceunion.push([XP5[n], YP5[n]]);
        if (n === 90) {
          P5 = new Point(XP5[n], YP5[n]);
        }
        usrvar["Plc" + n] =
          "(" +
          (XP5[n] - padding) / multiplier +
          "," +
          (hw + ArcFull - Arc * ((n - Theta) / (90 - Theta))) / multiplier +
          ")";
      }
      // console.log(scalearr);

      let lcrown = new Path({
        segments: scalearr,
      });
      if (!tracedimensions.iscrown) {
        // var lwline = new Path.Line(P3, P4);
        // lwline.style = style;
        traceunion.push([P4.x, P4.y]);
        traceunion.push([P3.x, P3.y]);
      }
      let union = new Path({
        segments: traceunion,
        style: style,
      });
      if (!tracedimensions.iscrown) {
        let tracelength = union["length"] / multiplier; //(rwline['length']+lwline['length'] + rcrown['length'] + lcrown['length'])/multiplier;
        usrvar["Tracelength"] = tracelength;
        usrvar["Tracecrown"] =
          (rcrown["length"] + lcrown["length"]) / multiplier;
        // union = rwline.unite(rcrown).unite(lcrown).unite(lwline);
      } else {
        let tracelength = union["length"] / multiplier; //(rcrown['length'] + lcrown['length'])/multiplier;
        usrvar["Tracelength"] = tracelength;
        usrvar["Tracecrown"] = tracelength;
        // union = rcrown.unite(lcrown);
      }
      console.log(union);
      //Creating point
      usrvar["XPmid"] = (XPmid - padding) / multiplier;
      let diff;

        let y;
        let pointheight = parseFloat(tracedimensions.pointheight) * multiplier;
        
        if (tracedimensions.heightfrom === "rightspl") {
          let distancefromcrown = (pointheight * ArcFull) / ws;
          y = P5.y + distancefromcrown;
        }
        if (tracedimensions.heightfrom === "leftspl") {
          let distancefromcrown = (pointheight * ArcFull) / ws;
          y = P5.y - distancefromcrown;
        }
        let circle = new Path.Circle(new Point(P1.x, y), 2);
       let crossing = new Path.Line(
          new Point(length+ padding, y),
          new Point(0, y)
        );
        // crossing.style=style;
        if (union.getIntersections(crossing).length > 0) {
          let startx = union.getIntersections(crossing)[0].point.x;
          diff = startx - P1.x;
          console.log(diff);
          let pointx = union.position.x - diff;
          let pointy = union.position.y;

          union.position = new Point(pointx, pointy);
        }
        circle.style = style;
        circle.fillColor = 'black';
      //logic for preventing curve going outside plot
      let start = new Path.Line(
        new Point(padding, 0),
        new Point(padding, props.dimensions.length * 35 + 400)
      );
      let interx = union.getIntersections(start);
      if (interx.length === 1) {
        let firstoffset = union.getOffsetOf(interx[0].point);
        let firstcut = union.splitAt(firstoffset);
        if (firstcut.segments[1].point.x < padding) {
          firstcut.opacity = 0;
        } else {
          union.opacity = 0;
        }
      }
      if (interx.length === 2) {
        let firstoffset = union.getOffsetOf(interx[0].point);
        let firstcut = union.splitAt(firstoffset);
        let secondoffset = firstcut.getOffsetOf(interx[1].point);
        let secondcut = firstcut.splitAt(secondoffset);

        if (firstcut.segments[2].point.x < padding) {
          firstcut.opacity = 0;
        } else {
          secondcut.opacity = 0;
          union.opacity = 0;
        }
      }
     //end logic
      usrvar["P1"] =
        "(" +
        ((P1.x - diff - padding) / multiplier).toFixed(1).replace(/\.0$/, "") +
        ",0)";
      usrvar["P2"] =
        "(" +
        ((P2.x - diff - padding) / multiplier).toFixed(1).replace(/\.0$/, "") +
        "," +
        (hw / multiplier).toFixed(1).replace(/\.0$/, "") +
        ")";
      usrvar["P3"] =
        "(" +
        ((P3.x - diff - padding) / multiplier).toFixed(1).replace(/\.0$/, "") +
        "," +
        ((2 * hw + ArcFull) / multiplier).toFixed(1).replace(/\.0$/, "") +
        ")";
      usrvar["P4"] =
        "(" +
        ((P4.x - diff - padding) / multiplier).toFixed(1).replace(/\.0$/, "") +
        "," +
        ((hw + ArcFull) / multiplier).toFixed(1).replace(/\.0$/, "") +
        ")";
      if (P5) {
        usrvar["P5"] =
          "(" +
          ((P5.x - diff - padding) / multiplier)
            .toFixed(1)
            .replace(/\.0$/, "") +
          "," +
          ((hw + Arc) / multiplier).toFixed(1).replace(/\.0$/, "") +
          ")";
      }
      usrvar["Pmid"] =
        "(" +
        ((Math.abs(X1-XP3)/2) / multiplier).toFixed(1).replace(/\.0$/, "") +
        "," +
        ((hw + Arc) / multiplier).toFixed(1).replace(/\.0$/, "") +
        ")";
      text = new PointText(
        new Point(padding, points + padding + 2 * (hw + Arc))
      );
      text.justification = "left";
      text.fillColor = 'black';
      text.content =
        "N" +
        String(Math.round(Dir)).padStart(3, "0") +
        "/" +
        amt +
        "\xB0" +
        " α =" +
        Alpha +
        "\xB0" +
        " β =" +
        toDegree(Math.atan(TanBeta)).toFixed(1).replace(/\.0$/, "") +
        "\xB0" +
        " Trace Length Total =" +
        usrvar["Tracelength"].toFixed(1).replace(/\.0$/, "") +
        " Trace Length of Crown=" +
        usrvar["Tracecrown"].toFixed(1).replace(/\.0$/, "");
      text = new PointText(
        new Point(padding, points + 15 + padding + 2 * (hw + Arc))
      );
      text.justification = "left";
      text.fillColor = 'black';
      text.content =
        "P1 =" +
        usrvar["P1"] +
        " P2 =" +
        usrvar["P2"] +
        " P3 =" +
        usrvar["P3"] +
        " P4 =" +
        usrvar["P4"] +
        " P5 =" +
        usrvar["P5"]+
        " Pmid =" +
        usrvar["Pmid"];
      points += 35;
      updateUserVariable(usrvar);
    
  };
  const createCaution = () => {
    const cautionY = points + padding + 2 * (hw + Arc);
    const cautionLabel = new PointText(new Point(padding, cautionY));
    cautionLabel.justification = "left";
    cautionLabel.fillColor = "black";
    cautionLabel.fontWeight = "bold";
    cautionLabel.content = "Caution:";
    const cautionText = new PointText(new Point(padding + cautionLabel.bounds.width + 4, cautionY));
    cautionText.justification = "left";
    cautionText.fillColor = "black";
    cautionText.content = "Discontinuity trace span may be evaluated with care in consideration of its persistence.";
  };

  const draw = (event) => {
    createScale();
    createLog();
    createTrace();
    createCaution();
  };
  const creategraph = () => {
    paper.project.clear();
    let width = length + 450;
    let height = 600;
    paper.view.viewSize = new Size(width, height);
    draw();
    paper.view.draw();
  };
  const toggleDebug = () => {
    let isDebug = props.showdebug;
    props.setshowdebug(!isDebug);
  };
  const addTrace = () => {
    props.addtrace();
  };
  const showDeleteTrace = () => {
    setShow(true);
  };
  const deleteTrace = () => {
    props.deletetrace(selectedTrace);
    setShow(false);
  };
  const selectTrace = (e) => {
    // let name = e.target.name;
    let value = e.target.value;
    // console.log(name);
    // console.log(value);
    setSelectedTrace(value);
  };
  return (
    <div id="page">
      <Header />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="row">
          <div className="col-md-12">
            <button
              onClick={() => {
                props.showinput();
              }}
              className="btn bg-green-dark mw-2 me-3"
            >
              Edit Input
            </button>
            <DownloadMenu filename="dshape-heading" screenLabel="D-shape Tunnel — Heading" feedbackInputs={props.dimensions} />
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-12 overflow-auto">
            {!props.showdebug ? (
              <canvas id="paper-canvas" resize="true" />
            ) : ''}
          </div>
        </div>
      </div>
      </div>
  );
};
export default Debugoutput;